import dayjs from 'dayjs'

import { IBonusHistoryItemDTO, IConvertedBonusHistory } from 'shared/models/BonusSystem'
import { IConvertedUserPromotions, IServerUserPromotion, IUserPromotion } from 'shared/models/Promotion'

import { IDefaultDataResponse } from '../PaymentApi/types/types'

export class BonusSystem {
  convertUserPromotionItem = (bonus: IServerUserPromotion): IUserPromotion => ({
    id: bonus.id,
    promotionId: bonus.promotion.id,
    active: bonus.promotion.active,
    status: bonus.status,
    name: bonus.promotion.name,
    expirationDate: dayjs(bonus.expiration_time).format('YYYY-MM-DD HH:mm:ss'),
    wager: +(+bonus.wager).toFixed(2),
    wagerCurrency: bonus.wager_currency,
    wagerComplete: +(+bonus.wager_completion).toFixed(2),
    wagerCompleteCurrency: bonus.wager_completion_currency,
    wagerCoefficient: bonus.promotion.wager_coefficient,
    depositCoefficient: bonus.promotion.deposit_coefficient,
    freeSpinsCount: bonus.freespins_count?.count || 0,
    freeSpinsGrantCount: bonus.promotion?.freespins_grant_amount || 0,
    promotionGrandAmount: Math.floor(+bonus.promotion_grant_amount * 100) / 100,
    promotionGrandAmountCurrency: bonus.promotion_grant_amount_currency,
    isFreeSpins: bonus.name.indexOf('freespins') === -1,
  })

  convertUserPromotions = (data: IDefaultDataResponse<IServerUserPromotion>): IConvertedUserPromotions => {
    const promos = data?.results.map(bonus => this.convertUserPromotionItem(bonus))

    return {
      page: data.page,
      count: data.count,
      promos,
    }
  }

  convertBonusHistory = (data: IDefaultDataResponse<IBonusHistoryItemDTO>): IConvertedBonusHistory => {
    const bonusHistory =
      data?.results?.map(item => ({
        id: item.id,
        amount: +(+item.amount).toFixed(2),
        amountCurrency: item.amount_currency,
        bonusBalanceBefore: +(+item.bonus_balance_before).toFixed(2),
        bonusBalanceBeforeCurrency: item.bonus_balance_before_currency,
        bonusBalanceAfter: +(+item.bonus_balance_after).toFixed(2),
        bonusBalanceAfterCurrency: item.bonus_balance_after_currency,
        date: dayjs(item.date).format('DD.MM.YYYY HH:mm'),
        type: item.type,
      })) || []

    return {
      page: data.page,
      count: data.count,
      history: bonusHistory,
    }
  }
}
